module.exports = __webpack_public_path__ + "static/AllTopSVGsSmall-18fb71ada9f59b2fe8460c3b7ee98762.svg";